module.exports = __webpack_public_path__ + "img/talmud.157b8e66.png";